import * as React from 'react';

interface IUseDisablePinDblClickZoomParams {
  map: YMaps.Map;
  balloonManager: YMaps.BalloonManager;
}

// ymaps зумит по синтетическому dblclick карты (из пары click), а нативный DOM-dblclick
// перехватывает прозрачный events-pane — поэтому гасим именно на map.events 'dblclick'
// через preventDefault, и только когда курсор над пином. Попадание в пин определяет ymaps
// своим hit-test'ом через mouseenter/mouseleave объектов ObjectManager.
export function useDisablePinDblClickZoom({ map, balloonManager }: IUseDisablePinDblClickZoomParams): void {
  React.useEffect(() => {
    const { objects } = balloonManager.objectManager;
    let isOverPin = false;

    const handlePinEnter = () => {
      isOverPin = true;
    };

    const handlePinLeave = () => {
      isOverPin = false;
    };

    const handleMapDblClick = (event: YMaps.IEvent) => {
      if (!isOverPin) {
        return;
      }

      event.preventDefault();
    };

    objects.events.add('mouseenter', handlePinEnter);
    objects.events.add('mouseleave', handlePinLeave);
    map.events.add('dblclick', handleMapDblClick);

    return () => {
      objects.events.remove('mouseenter', handlePinEnter);
      objects.events.remove('mouseleave', handlePinLeave);
      map.events.remove('dblclick', handleMapDblClick);
    };
  }, [map, balloonManager]);
}
